import styled from 'styled-components';

export const StartLiveFormContainer = styled.div`
  margin: 10px auto;
  max-width: 500px;

  p {
    margin-bottom: 1rem;
  }
`;